import { render, staticRenderFns } from "./show-details.vue?vue&type=template&id=12a4ddfc&scoped=true"
import script from "./show-details.vue?vue&type=script&lang=js"
export * from "./show-details.vue?vue&type=script&lang=js"
import style0 from "./show-details.vue?vue&type=style&index=0&id=12a4ddfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4ddfc",
  null
  
)

export default component.exports